import { z } from 'zod/v4';


export const LSSuburbSchema = z.object({
    suburbKey: z.string(),
    suburb1: z.string(),
    state: z.string(),
    postCode: z.string(),
    region: z.string(),
    localityId: z.string(),
});

export type LSSuburb = z.infer<typeof LSSuburbSchema>;